import { Component, input, OnChanges, ViewChild } from '@angular/core';

import { ChartConfiguration, ChartOptions, Plugin } from 'chart.js';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-bar-chart',
  standalone: true,
  imports: [BaseChartDirective],
  templateUrl: './bar-chart.component.html',
  styleUrl: './bar-chart.component.scss',
})
export class BarChartComponent implements OnChanges {
  private readonly referenceLinePlugin: Plugin<'bar'> = {
    id: 'referenceLine',
    afterDatasetsDraw: (chart) => {
      const referenceValue = this.referenceValue();

      if (referenceValue === null || referenceValue === undefined) {
        return;
      }

      const yScale = chart.scales['y'];

      if (!yScale) {
        return;
      }

      const yPosition = yScale.getPixelForValue(referenceValue);
      const {
        ctx,
        chartArea: { left, right },
      } = chart;

      ctx.save();
      ctx.beginPath();
      ctx.setLineDash([6, 4]);
      ctx.lineWidth = 2;
      ctx.strokeStyle = '#1B1B1B';
      ctx.moveTo(left, yPosition);
      ctx.lineTo(right, yPosition);
      ctx.stroke();
      ctx.restore();
    },
  };

  public pieChartPlugins = [DataLabelsPlugin, this.referenceLinePlugin];

  public barChartOptions: ChartOptions<'bar'> = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        stacked: false,
      },
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          callback: (value) => {
            return value + '%';
          },
        },
        stacked: false,
      },
    },
    plugins: {
      datalabels: {
        formatter: function (value, context: any) {
          let custom: string[] = [];
          if (context.dataset.custom) {
            custom = context.dataset.custom.split(',');
          }
          return `${value}%\n ${
            custom.length ? custom[context.dataIndex] : ''
          }`;
        },
        color: 'white',
        anchor: 'center',
        align: 'center',
        textAlign: 'center',
        clamp: true,
        font: {
          size: 10,
          weight: 'bolder',
        },
      },
      tooltip: {
        callbacks: {
          title: function(context) {
            return context[0].label;
          },
          label: function (context) {
            const value = context.parsed.y;
            const dataset = context.dataset as any;            
            const labels = [`${value}%`];
            
            if (dataset.responseCount && dataset.responseCount[context.dataIndex]) {
              const responseCount = dataset.responseCount[context.dataIndex];
              labels.push(`${responseCount} respostas`);
            }
            
            return labels;
          },
        },
      },
    },
    elements: {
      point: {
        radius: 5,
        hoverRadius: 7,
      },
      bar: {
        borderWidth: 2,
      },
    },
  };
  // Tipos de gráfico
  barChartLegend = true;

  public barChartData: ChartConfiguration<'bar'>['data'] = {
    labels: [],
    datasets: [],
  };

  data = input.required<ChartConfiguration<'bar'>['data']>();
  text = input.required<string>();
  referenceValue = input<number | null>(null);
  referenceLabel = input<string | null>(null);

  @ViewChild(BaseChartDirective) chartData?: BaseChartDirective<'bar'>;

  ngOnChanges(): void {
    this.barChartData = this.data();

    this.chartData?.update();
  }
}
